<template>
  <div class="box">
    <b-loading
      v-if="isLoading"
      :is-full-page="false"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <div class="columns has-text-left important-message">
      <div class="column is-narrow">
        <b-button
          rounded
          type="is-zero"
          style="padding: 1.2rem; cursor: default;"
        >
          <b-icon
            icon="microphone-alt"
            type="is-fff"
            style="position: relative; top: 2px;"
          ></b-icon>

          <b class="has-text-fff" style="position: relative; bottom: 4px;">
            IMPORTANTE
          </b>
        </b-button>
      </div>

      <div class="column has-text-zero">
        Os 2 representantes poderão solicitar Ações de Desenvolvimento em nome
        da OE e poderão ser trocados a qualquer momento.
      </div>
    </div>

    <h2 class="has-text-weight-bold">
      Editar Representante 1 (você)
    </h2>
    <br />

    <div class="columns">
      <div class="column">
        <!-- OE - Lider 1: email -->
        <b-field
          :label="oe.leader1.email ? 'E-mail' : ''"
          label-position="on-border"
        >
          <b-input v-model="oe.leader1.email" disabled></b-input>
        </b-field>
      </div>

      <div class="column">
        <!-- OE - Lider 1: nome -->
        <b-field
          :label="oe.leader1.name ? 'Nome' : ''"
          label-position="on-border"
        >
          <b-input v-model="oe.leader1.name" disabled></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <!-- OE - Lider 1: curso -->
        <b-field
          :label="oe.leader1.course ? 'Curso' : ''"
          label-position="on-border"
        >
          <b-input v-model="oe.leader1.course" disabled></b-input>
        </b-field>
      </div>

      <div class="column">
        <!-- OE - Lider 1: posicao -->
        <b-field
          :label="oe.leader1.position ? 'Posição na OE' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="oe.leader1.position"
            placeholder="Sua Posição na OE"
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <!-- OE - Lider 1: telefone -->
        <b-field
          :label="oe.leader1.areacode ? 'DDD + Celular' : ''"
          label-position="on-border"
        >
          <b-select v-model="oe.leader1.areacode" id="leader1areacode">
            <option value="">DDD</option>
          </b-select>

          <b-input
            v-model="oe.leader1.cellphone"
            placeholder="Seu Celular"
            type="tel"
            expanded
            @input.native="formatCellphoneWithoutAreacode('leader1cellphone')"
          ></b-input>
        </b-field>
      </div>
    </div>

    <h2 class="has-text-weight-bold">
      Editar Representante 2
    </h2>
    <br />

    <div class="columns">
      <div class="column">
        <!-- OE - Lider 2: email -->
        <b-field
          :label="oe.leader2.email ? 'E-mail' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="oe.leader2.email"
            placeholder="E-mail pessoal"
            @blur="checkStudentEmail"
            disabled
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <!-- OE - Lider 2: nome -->
        <b-field
          :label="oe.leader2.name ? 'Nome' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="oe.leader2.name"
            placeholder="Nome completo"
            disabled
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <!-- OE - Lider 2: curso -->
        <b-input
          v-model="oe.leader2.course"
          placeholder="Exemplo: Administração"
          disabled
        ></b-input>
      </div>

      <div class="column">
        <!-- OE - Lider 2: posicao -->
        <b-field
          :label="oe.leader2.position ? 'Posição na OE' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="oe.leader2.position"
            placeholder="Posição na OE"
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <!-- OE - Lider 2: telefone -->
        <b-field
          :label="oe.leader2.areacode ? 'DDD + Celular' : ''"
          label-position="on-border"
        >
          <b-select v-model="oe.leader2.areacode" id="leader2areacode">
            <option value="">DDD</option>
          </b-select>
          <b-input
            v-model="oe.leader2.cellphone"
            placeholder="Celular"
            type="tel"
            expanded
            @input.native="formatCellphoneWithoutAreacode('leader2cellphone')"
          ></b-input>
        </b-field>
      </div>
    </div>

    <b-button
      class="button is-primary is-rounded"
      style="display: block; margin: auto;"
      @click="$router.push('/changeleaders')"
    >
      Trocar Representantes
    </b-button>

    <br />

    <h2 class="has-text-weight-bold">
      Informe, pelo menos, mais dois integrantes da OE
    </h2>
    <br />

    <div
      v-for="(contact, index) in oe.otherContacts"
      :key="`contact-${index}`"
      style="margin-bottom: 1rem"
    >
      <oe-contact
        :contact="contact"
        :index="index"
        @add-contact="addContact"
        @remove-contact="removeContact"
      />
    </div>

    <Pendencies :pendencies="pendencies" />

    <div>
      <button
        class="button is-primary is-rounded"
        style="margin-left: auto; display: block;"
        @click="updateOrganization"
        :disabled="pendencies.length > 0"
      >
        Salvar
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ddds } from "../../../assets/js/ddds";
import { commom } from "../../../mixins/commom";
import { mask } from "../../../mixins/mask";
import oeContact from "../OEContact";
import Pendencies from "../../commom/Pendencies.vue";

export default {
  name: "FormLeaders",

  props: ["oe"],

  mixins: [commom, mask],

  components: {
    oeContact,
    Pendencies
  },

  data() {
    return {
      isLoading: false,
      leader1cellphone: "",
      leader2cellphone: ""
    };
  },

  methods: {
    addContact() {
      this.oe.otherContacts.push({
        name: "",
        email: ""
      });
    },

    removeContact(index) {
      if (this.oe.otherContacts.length > 2) {
        this.oe.otherContacts.splice(index, 1);
      }
    },

    updateCourse(course, leader) {
      this.oe[leader].course = course;
    },

    checkStudentEmail() {
      this.isLoading = true;
      this.$store
        .dispatch("checkStudentEmail", {
          email: this.oe.leader2.email
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.oe.leader2.name = `${res.data.payload.name} ${res.data.payload.surname}`;
            this.oe.leader2.course = res.data.payload.course;
            this.$refs.leader2course.localCourse = res.data.payload.course;
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateOrganization() {
      this.isLoading = true;

      this.$store
        .dispatch("updateOrganization", {
          oe: this.oe
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.showOrganizationEmailInput = false;
            this.$buefy.dialog.alert({
              title: "Sucesso!",
              message: "As informações dos representantes da OE foram atualizadas 😉",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa"
            });
            if (this.oe.fanpage) {
              this.oeHasFanpage = true;
              if (this.oe.fanpage.indexOf("https") === -1) {
                this.oe.fanpage = "https://www.facebook.com/" + this.oe.fanpage;
              }
            }
            if (this.oe.insta) {
              this.oeHasInsta = true;
              if (this.oe.insta.indexOf("https") === -1) {
                this.oe.insta = "https://www.instagram.com/" + this.oe.insta;
              }
            }
            if (this.oe.linkedin) {
              this.oeHasLinkedin = true;
              if (this.oe.linkedin.indexOf("https") === -1) {
                this.oe.linkedin =
                  "https://www.linkedin.com/company/" + this.oe.linkedin;
              }
            }
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  computed: {
    ...mapGetters(["account"]),

    pendencies() {
      const pendencies = [];

      if (this.oe.leader1.email == "") {
        pendencies.push("E-mail do Representante 1");
      }

      if (this.oe.leader1.position == "") {
        pendencies.push("Posição na OE do Representante 1");
      }

      if (this.oe.leader2.email == "") {
        pendencies.push("E-mail do Representante 2");
      }

      if (this.oe.leader2.position == "") {
        pendencies.push("Posição na OE do Representante 2");
      }

      if (this.oe.otherContacts.length < 2) {
        pendencies.push("A OE precisa ter pelo menos mais dois integrantes");
      }

      for (let i = 0; i < this.oe.otherContacts.length; i++) {
        if (this.oe.otherContacts[i].name == "") {
          pendencies.push("Nome do integrante " + (i + 1));
        }
        if (this.oe.otherContacts[i].email == "") {
          pendencies.push("E-mail do integrante " + (i + 1));
        }
      }

      return pendencies;
    }
  },

  watch: {
    leader1cellphone(value) {
      this.oe.leader1.cellphone = value;
    },
    leader2cellphone(value) {
      this.oe.leader2.cellphone = value;
    }
  },

  mounted() {
    this.isLoading = false;
    this.oe.leader1.name = this.account.name + " " + this.account.surname;
    this.oe.leader1.email = this.account.email;
    this.oe.leader1.course = this.account.course;

    let dddsOptions = "";
    const dddslen = ddds.length;
    for (let i = 0; i < dddslen; i++) 
      dddsOptions += `<option value="${ddds[i]}">${ddds[i]}</option>`;
    document.getElementById("leader1areacode").innerHTML += dddsOptions;
    document.getElementById("leader2areacode").innerHTML += dddsOptions;
  }
};
</script>

<style scoped>
.box {
  padding: 2rem 3rem;
  max-width: 800px !important;
  margin: auto;
}
.important-message {
  margin: -1rem;
}
@media (max-width: 400px) {
  .box {
    padding: 0.5rem !important;
  }
}
</style>
